.drawerBackground {
    background-color: var(--mantine-color-dark-5);
}

.drawerBody {
    padding: 0;
}

.badge {
    padding: 2px 4px;
    text-transform: none;
}
